"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_MESSAGE_DEFAULT = exports.URL_BASE = exports.URL_ROOT = void 0;
const API_VERSION = 'v1';
exports.URL_ROOT = '/';
exports.URL_BASE = `${exports.URL_ROOT}webapi/${API_VERSION}`;
exports.ERROR_MESSAGE_DEFAULT = 'Error, our specialists already know about it and take measures';
